// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "main.min.css";
	// return url for filenames based on template
	return "" + chunkId + ".main.min.css";
};